module.exports = __webpack_public_path__ + "img/print-icon.d28abd9d.svg";